<template>
  <v-card v-if="loading" class="pa-16" style="height: 100vh">
    <h2 class="text-center">
      <v-progress-circular
          class="mr-2"
          color="primary"
          indeterminate
      ></v-progress-circular
      >
      Loading...
    </h2>
  </v-card>
  <v-card v-else class="pa-2" style="min-height: 100vh">
    <v-card>
      <v-layout align-self-center class="p-3" row wrap>
        <v-flex class="p-2" xs3>
          <v-autocomplete
              v-model="facilityTypeValue"
              :clearable="clearable"
              :items="FACILITY_TYPES"
              :loading="loading"
              item-text="name"
              item-value="id"
              label="Facility Type"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-row>
        <v-col cols="6">
          <v-card class="py-8">
            <v-card-subtitle>
              <b>Online Status</b>
            </v-card-subtitle>
            <apexchart :options="chartOptions" :series="OnlineStatusChart" type="donut"
                       @dataPointSelection="clickHandler"></apexchart>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-data-table
              :headers="headers"
              :items="OnlineStatusTable"
              :loading="loading"
              loading-text="Loading... please wait">
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
import {OnlineStatusService} from "@/components/OnlineStatus/onlineStatus.service";
import {getFacilityTypes} from "@/utils/helper";

export default {
  name: "VueChart",
  components: {},
  data() {
    return {
      OnlineStatusChart: [],
      OnlineStatusTable: [],
      headers: [
        {text: "Name", value: "name"},
        {text: "Last Login", value: "lastLoginDate"},
        {text: "Sector", value: "sector"}
      ],
      loading: false,
      chartOptions: {
        chart: {
          type: "donut",
          toolbar: {
            show: true,
          },
        },
        download: true,
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 100
            },
          },
        }],
        labels: ['0-7 days', '8-14 days', '15-30 days', '>30 days'],
      },

      FACILITY_TYPES: [],
      clearable: true,
      facilityTypeValue: null,
      selected: null,
      allData: []
    };
  },
  watch: {
    facilityTypeValue: {
      handler: function () {
        this.fetchOnlineStatus();
      },
    },
  },
  async created() {
    await this.fetchOnlineStatus();
    await this.initateLookups();
  },
  methods: {
    async fetchOnlineStatus() {
      this.loading = true;
      let searchParams = '';
      this.facilityTypeValue !== null && (searchParams += '?facilityTypeId=' + this.facilityTypeValue);
      const onlineStatusResp = await OnlineStatusService.getOnlineStatus(searchParams);
      this.allData = onlineStatusResp.data;
      this.OnlineStatusTable = onlineStatusResp.data;

      this.OnlineStatusChart = [0, 0, 0, 0];
      this.OnlineStatusTable.forEach(item => {
        let today = new Date(new Date().toISOString().split('T')[0]);
        let lastLoginDate = new Date(item.lastLoginDate);
        let diffTime = Math.abs(today - lastLoginDate) / (24 * 60 * 60 * 1000);

        if (diffTime < 7) {
          this.OnlineStatusChart[0] += 1;
        } else if (diffTime < 14) {
          this.OnlineStatusChart[1] += 1;
        } else if (diffTime < 30) {
          this.OnlineStatusChart[2] += 1;
        } else {
          this.OnlineStatusChart[3] += 1;
        }
      });
      this.loading = false;
    },
    async initateLookups() {
      this.loading = true;
      this.FACILITY_TYPES = await getFacilityTypes();
      this.loading = false;
    },
    clickHandler(event, chartContext, config) {
      this.selected = config.dataPointIndex;
      this.OnlineStatusTable = this.allData.filter(item => {
        let today = new Date(new Date().toISOString().split('T')[0]);
        let lastLoginDate = new Date(item.lastLoginDate);
        let diffTime = Math.abs(today - lastLoginDate) / (24 * 60 * 60 * 1000);
        if (this.selected === 0) {
          return diffTime < 7;
        } else if (this.selected === 1) {
          return diffTime < 14 && diffTime > 7;
        } else if (this.selected === 2) {
          return diffTime < 30 && diffTime > 14;
        } else {
          return diffTime > 30 && diffTime > 30;
        }
      });
    },
  },
};
</script>

<style scoped>
.iCountUp {
  font-size: 1em;
  margin: 0;
  color: #1976d2;
}
</style>
